import { createContext } from "react";

import { UserGetMyselfResponseType } from "../api/responses/userResponseTypes";

import {
  UserType,
  RoleType,
  GroupType,
  PolicyType,
  AttributeMetadataType,
  ScopeType
} from "../api/types";

export type DataContextType = {
  users: UserType[];
  roles: RoleType[];
  groups: GroupType[];
  myself?: UserGetMyselfResponseType;
  policies: PolicyType[];
  attributeMetadatas: AttributeMetadataType[];
  scopes:ScopeType[];
  fetchUsers: () => void;
  fetchRoles: () => void;
  fetchGroups: () => void;
  fetchMyself: () => Promise<void>;
  fetchPolicies: () => void;
  fetchAttributeMetadatas: () => void;
  fetchScopes: () => void;
};

const initialState: DataContextType = {
  users: [],
  roles: [],
  groups: [],
  policies: [],
  attributeMetadatas: [],
  scopes: [],
  fetchUsers: () => {},
  fetchRoles: () => {},
  fetchGroups: () => {},
  fetchMyself: () => Promise.reject(),
  fetchPolicies: () => {},
  fetchAttributeMetadatas: () => {},
  fetchScopes: () => {}
};

export default createContext(initialState);
